/**
 * Subscriber status badge — pending=amber, verified=green, disabled=grey.
 * Tone logic lives in shared.tsx (subscriberStatusTone) — single source of truth.
 */
import { Badge } from '@vnetwork/ui/primitives';
import type { SubscriberStatus } from '@/api/healthcheck';
import { subscriberStatusTone } from '../shared';

interface Props {
  status: SubscriberStatus;
}

export function SubscriberStatusBadge({ status }: Props) {
  return (
    <Badge tone={subscriberStatusTone(status)} appearance="subtle" size="sm" style={{ textTransform: 'capitalize' }}>
      {status}
    </Badge>
  );
}
